import { IconButton, SvgIcon } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { palette, spaces } from '../../../../../assets/styles/themes/tokens';
import getMuiIcon from '../../../../../utils/getMuiIcon';

const SendButton = ({ disabled }: { disabled: boolean }) => {
  const { t } = useTranslation();
  return (
    <IconButton
      type='submit'
      data-testid='ai-assistant-send-button'
      sx={{ padding: spaces.xxs }}
      disabled={disabled}
      aria-label={t('Send')}
    >
      <SvgIcon
        sx={{
          width: 24,
          height: 24,
          color: disabled ? palette.action.disabled : palette.primary.main
        }}
        viewBox='0 0 35 35'
        component={getMuiIcon('sendBold')}
        aria-hidden='true'
      /> 
    </IconButton>
  );
};

export default SendButton;
